import { createRoute } from "@tanstack/react-router";
import { UserPen } from "lucide-react";
import { Suspense } from "react";
import { z } from "zod";
import ContentFrame from "@/components/ContentFrame";
import SidePanel from "@/components/SidePanel";
import SimpleTaskListHeader from "@/components/SimpleTaskListHeader";
import TaskListRouteSkeleton from "@/components/TaskListRouteSkeleton";
import { TaskQueryParamsProvider } from "@/components/task-table/TaskQueryParamsContext";
import TasksTable from "@/components/task-table/TasksTable";
import { useRouteTaskQueryParams } from "@/hooks/task-query-params/useRouteTaskQueryParams";
import { appRoute } from "./appRoute";

const createdByMeSearchSchema = z.object({
    task: z.coerce.number().optional(),
    filter: z.any().optional(),
    tab: z.string().optional(),
});

function CreatedByMePage() {
    const queryParams = useRouteTaskQueryParams({ taskListId: undefined, type: "created-by-me" });

    return (
        <ContentFrame>
            <TaskQueryParamsProvider value={queryParams}>
                <Suspense fallback={<TaskListRouteSkeleton />}>
                    <SimpleTaskListHeader title="Created by me" icon={UserPen} />
                    <TasksTable key="tasklist-created-by-me" disabled={false} />
                </Suspense>

                {/* Right Panel */}
                <SidePanel />
            </TaskQueryParamsProvider>
        </ContentFrame>
    );
}

export const createdByMeRoute = createRoute({
    getParentRoute: () => appRoute,
    path: "/created-by-me",
    validateSearch: createdByMeSearchSchema,
    component: CreatedByMePage,
});
